import { render } from "./SidebarLinkGroup.vue?vue&type=template&id=e703de34"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__